import React, { useState, useEffect, useCallback } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import {useDataRefresh, ViewModelForm} from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { UserService } from 'gw-capability-gateway';
import { MLLocalDateUtil, MLErrorMessageUtil } from 'ml-portals-util-js';
import { MLNotificationBlockUtil, MLWizardNavUtil } from 'ml-portals-util-react';
import { MLMultiLobsDataHolderService } from 'ml-services-common-react';
import { MLModifierComponent } from 'ml-components-common-react';
import { MLModalService } from 'ml-portals-services-react';
import { platformMessages } from 'ml-components-platform-react';
import appConfig from 'app-config';
import HOTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/HOTrackEvent';
import metadata from './AdditionalDiscountsPage.metadata.json5';
import messages from './AdditionalDiscountsPage.messages';
import { ScrollToError } from '@jutro/legacy/wizard-next';
import {LoadSaveService} from "gw-capability-gateway-quoteandbind";
import { MultipleSelect, SelectOption} from '@jutro/components';
import { CheckboxGroupFieldInternal } from '@jutro/legacy/components/CheckboxGroupField/CheckboxGroupFieldInternal';
import styles from './AdditionalDiscountsPage.module.scss'

// HORatingCtrl.js, ho-rating.html
function AdditionalDiscountsPage(props) {
    const translator = useTranslator();
    const {
        wizardData: submissionVM,
        updateWizardData,
        currentStep,
        isSkipping,
        goNext,
        history,
        steps
    } = props;
    const [showErrors, updateShowErrors] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const {
        onValidate,
        isComponentValid,
        initialValidation
    } = useValidation('AdditionalDiscountsPage');
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { authHeader } = useAuthentication();

    const [inSync, setInSync] = useState(false);
    const [dateModifiersInvalid, updateDateModifiersInvalid] = useState([]);
    const modifiers = _.get(submissionVM, 'lobData.homeowners.modifiers_ML');
    const isRentalPolicy = _.get(submissionVM, 'lobData.homeowners.coverables.coveragePartType_ML.value') === 'hoprental';
    const isGpa = appConfig.portalCode === 'GPA';
    const isQnB = appConfig.portalCode === 'QB';
    const multipolicyLobCodes = ['HOPMultiPolicyNumber_ML', 'HOPPrimaryResidenceWithMetLifePolicyNumber_ML', 'HOPHomeOrLandlordHomePolicyNumber_ML', 'HOPLandlordHomePolicyNumber_ML'];
    const hopYearUpdatedModifiers = ['HOPElectricalYearUpdated_ML', 'HOPPlumbingYearUpdated_ML', 'HOPHeatingYearUpdated_ML'];
    const [showReturnToQuote, setShowReturnToQuote] = useState(false);
    const [canRequote, setCanRequote] = useState(false);
    const quoteStep = steps.find((step) => step.mlStepName === 'quoteDetails');
    let returnToQuoteClicked = false;
    const { refreshData } = useDataRefresh();
    const [tenantScreeningValues, updateTenantScreeningValues] = useState([]);
    const [inValidOptionSelected, updateInValidOptionSelected] = useState(undefined);

    const {nextStepVisited, canShowReturnToQuoteButton, isLastStep} = MLWizardNavUtil(props);

    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const modifierToRemoveFromDiscounts = ["HOP_PlumbingType_ML", "HOPWiringType_ML"];
    const isLandlordHome = submissionVM.value.isLandlordHome();
    const isLandlordCondo = submissionVM.value.isLandlordCondo();
    const isHomeOwner = submissionVM.value.isDwelling();
    const isRenters = submissionVM?.value?.isRenters();
    const defensibleValue = _.get(submissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.defensibleDiscount.value', undefined);
    const occupancyType = _.get(submissionVM, 'lobData.homeowners.preQualQuestionSets.value[0].answers.HOPPreQualLandlordDwellingOccupancy_Ext' , undefined);

    const isOccupancyVacant = occupancyType === 'HOPPreQualLandlordOccupancyVacant';

    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
    } = MLModalService();
    const {
        clearBlockAlerts,
        clearErrorAlerts,
        addWarningAlert,
        addErrorAlert
    } = MLNotificationBlockUtil();

    const fullDateMods = ['HOPHomePurchaseDate_Ext', 'HOPIBHSCertDate_ext'];

    const HOP_POLICY_NUMBER_MODIFIERS = [
        'HOPMultiPolicyNumberAuto_Ext',
        'HOPAnotherPrimSeasSecPropertyPolicyNumber_Ext',
        'HOPPrimSeasSecPropertyPolicyNumber_Ext',
        'HOPMultiPolicyNumberLandlord_Ext',
        'HOPMultiPolicyNumberUmbrella_Ext',
        'HOPMultiPolicyNumberBoat_Ext',
        'HOPMultiPolicyNumberMotorcycle_Ext',
        'HOPMultiPolicyNumberRecreationalVehicle_Ext',
        'HOPMultiPolicyNumberOffRoadVehicle_Ext'
    ];



    if (modifiers && modifiers.lineModifiers_ML?.value) {
        modifiers.lineModifiers_ML.value.forEach(
            (mod) => {
                if (multipolicyLobCodes.includes(mod?.codeIdentifier_ML) || HOP_POLICY_NUMBER_MODIFIERS.includes(mod?.codeIdentifier_ML)) {
                    mod.isVisible_ML = false
                    mod.isInputValueRequired_ML = false
                    mod.editMode_ML = false
                    mod.savedFromPortal = false
                } else {
                    mod.isVisible_ML = true
                }
            }
        );
    }

    const syncModifiers = (submissionData, mlModifier) => {
         const isLineModifier = mlModifier === modifiers.lineModifiers_ML;         
        submissionData.forEach((mod) => {
            const oldMod = mlModifier.value.find((value) => {
                return value.patternCode === mod.patternCode;
            });
            if (mod?.codeIdentifier_ML === "HOPMultiPolicy_ML" && mod.chosenTermValue === "true") {
                _.set(submissionVM, 'lobData.homeowners.preQualQuestionSets.value[0].answers.HOPPreQualAutoPolicyExists_Ext', true);
            }
            if (isLineModifier) {
                _.set(mod, 'chosenTermValue', oldMod?.chosenTermValue ?? mod.chosenTermValue ?? 'false');
            }
            else {
                _.set(mod, 'chosenTermValue', oldMod ? oldMod.chosenTermValue : null);
            }
            if (!multipolicyLobCodes.includes(mod?.codeIdentifier_ML) || !HOP_POLICY_NUMBER_MODIFIERS.includes(mod?.codeIdentifier_ML)) {
                _.set(mod, 'savedFromPortal', true);
                _.set(mod, 'editMode_ML', true);
            }
        });
        _.set(mlModifier, 'value', submissionData);
    };

    const setCanRequoteFlag = useCallback ( async() => {
        setCanRequote(showReturnToQuote && _.get(quoteStep, 'visited') !== true);
    }, [quoteStep, showReturnToQuote]);

    useEffect(() => {
        if (!isSkipping) {
            if (isGpa) {
                UserService.getCurrentUser(authHeader).then((user) => {
                    HOTrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'Discount Page'});
                });
            } else {
                    HOTrackEvent('Quote Step Reached', isSkipping, submissionVM, null, { step: 'Discount Page'}, true);
            }
        }
        
        canShowReturnToQuoteButton(submissionVM, authHeader, quoteStep).then((response) => {
            setShowReturnToQuote(!!response);
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setCanRequoteFlag();
    }, [setCanRequoteFlag, submissionVM]);

    const updateAndSyncModifier = (mod, modal) => {
        _.set(mod, 'updated.value', true);

        const validLineMods = [];
        const validDwellingMods = [];
        const copiedModel = _.cloneDeep(submissionVM.value);

        for (let i = 0; i < modifiers.lineModifiers_ML.children.length; i += 1) {
            const modifier = modifiers.lineModifiers_ML.children[i];
            if (modifier.aspects.subtreeValid) {
                validLineMods.push(modifier.value);
            }
        }

        for (let i = 0; i < modifiers.dwellingsModifiers_ML.children.length; i += 1) {
            const modifier = modifiers.dwellingsModifiers_ML.children[i];
            if (modifier.aspects.subtreeValid) {
                validDwellingMods.push(modifier.value);
            }
        }

        _.set(copiedModel, 'lobData.homeowners.modifiers_ML.lineModifiers_ML', validLineMods);
        _.set(copiedModel, 'lobData.homeowners.modifiers_ML.dwellingsModifiers_ML', validDwellingMods);
        if (!inSync) {
            // "updateModifiers" was called multiple times so that it has caused CDCE error.
            // Here it controls to make sure to call one at a time
            const submissionLoadPromise = LoadSaveService.updateModifiers(copiedModel, authHeader);
            setInSync(true);
            if (modal) {
                    showProgressDialog(platformMessages.syncingDiscounts, submissionLoadPromise, true);
            }
            submissionLoadPromise.then((submissionData) => {
                syncModifiers(submissionData.lobData.homeowners.modifiers_ML.lineModifiers_ML, modifiers.lineModifiers_ML);
                syncModifiers(submissionData.lobData.homeowners.modifiers_ML.dwellingsModifiers_ML, modifiers.dwellingsModifiers_ML);
                updateWizardData(submissionVM);
            }).catch(error => {
                // US963263: Handle CDC Exceptions using Generic Error Handler
                MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
            }).finally(() => {
                setInSync(false);
                hideProgressDialog();
            });
        }
    };

    const isModifierTypeDate = (mod) => {
        return mod.valueType.value === 'date' && mod.dateValue_ML;
    };

    const isDateModifierPeriodValid = (mod) => {
        return mod.dateValue_ML?.year?.value >= 1900 && mod.dateValue_ML?.year?.value < 2100
            && mod.dateValue_ML?.aspects && mod.dateValue_ML?.aspects.valid;
    };


    const addAlertIfDateModifiersArePriorToYearBuilt = (mod) => {
        const clonedDateModifiersInvalid = [...dateModifiersInvalid];
        const alertAlreadyExists = clonedDateModifiersInvalid.includes(mod.name.value);
        if (mod.dateValue_ML?.value.year < submissionVM.value.lobData.homeowners.coverables.constructionVeriskDetails_ML.yearBuilt && !alertAlreadyExists) {
            clonedDateModifiersInvalid.push(mod.name.value);
        } else if (alertAlreadyExists) {
            clonedDateModifiersInvalid.splice(clonedDateModifiersInvalid.indexOf(mod.name.value), 1);
        }
        updateDateModifiersInvalid(clonedDateModifiersInvalid);
    };

    const isDwellingModYearPriorToYearBuilt = (mod) => mod?.dateValue_ML?.value?.year < submissionVM.value.lobData.homeowners.coverables.constructionVeriskDetails_ML.yearBuilt;
    const isDwellingModYearAfterTodaysYear = (mod) => {
        const today = new Date();

        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth();

        return mod?.dateValue_ML?.value?.year > currentYear || (mod?.dateValue_ML?.value?.year === currentYear && mod?.dateValue_ML?.value?.month > currentMonth);
    }

    const validatePriorDateModifiersOnContinue = (dwellingMods) => {
        const dateErrors = [];

        dwellingMods.forEach((mod) => {
            if (hopYearUpdatedModifiers.includes(mod?.value?.codeIdentifier_ML)){
                if (isDwellingModYearPriorToYearBuilt(mod)) {
                    dateErrors.push(mod.name.value);
                }
            }
        })

        return dateErrors;
    };

    const validateFutureDateModifiersOnContinue = (dwellingMods) => {
        const dateErrors = [];

        dwellingMods.forEach((mod) => {
            if (hopYearUpdatedModifiers.includes(mod?.value?.codeIdentifier_ML)){
                if (isDwellingModYearAfterTodaysYear(mod)) {
                    dateErrors.push(mod.name.value);
                }
            }
        })

        return dateErrors;
    };

    const isADeviceSelected = (value) => {
        const dwellings = modifiers.dwellingsModifiers_ML.value;
        return typeof (dwellings.find((m) => m.chosenTermValue === value)) !== 'undefined';
    };

    const areHoneywellDevicesSelected = () => {
        return (isADeviceSelected('self_mon_honeywell_lyric') || isADeviceSelected('honeywell_lyric'));
    };

    const setRemainderWarning = () => {
        clearBlockAlerts('SmartHomeValidationEmail');
        if (areHoneywellDevicesSelected()) {
            const emailAddress = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.emailAddress1.value');
            const warningMsg = (
                <FormattedMessage
                    {...messages.warningMessage}
                    values={{
                        importantReminder: <strong>{translator(messages.importantReminder)}</strong>,
                        confirmEmailAddress: translator(messages.confirmEmailAddress, { email: emailAddress })
                    }}
                />
            );
            addWarningAlert(warningMsg, 'SmartHomeValidationEmail');
        }
    };

    const updateModifier = (mod, modal = true) => {
        if (isModifierTypeDate(mod)) {
            if (isDateModifierPeriodValid(mod)) {
                updateAndSyncModifier(mod, modal);
                
                if (hopYearUpdatedModifiers.includes(mod?.value?.codeIdentifier_ML) && !isDwellingModYearPriorToYearBuilt(mod)){
                    clearBlockAlerts(`${mod.name.value} - Prior`);
                }
                if (hopYearUpdatedModifiers.includes(mod?.value?.codeIdentifier_ML) && !isDwellingModYearAfterTodaysYear(mod)){
                    clearBlockAlerts(`${mod.name.value} - After`);
                }

                addAlertIfDateModifiersArePriorToYearBuilt(mod);
            }
        } else {
            updateAndSyncModifier(mod, modal);
        }

        if (isGpa) {
            setRemainderWarning();
        }
    };

    const skipOnResumeIf = () => {
        const jumpToQuote = _.get(history, 'location.state.jumpToQuote', false)

        if (jumpToQuote) {
            return initialValidation().then((isValid) => !!isValid);
        } else {
            if (!!_.get(submissionVM, 'bindData.policyNumber.value')
                && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
                return true;
            }

            if (MLMultiLobsDataHolderService.getLastVisitedStep() === currentStep.mlStepName) {
                return false;
            }

            if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'quoteDetails' &&
                submissionVM.hvqQuoteID_ML.value &&
                submissionVM.isBundle_ML.value) {
                return true;
            }

            if (submissionVM.value.isBundle_ML
                && submissionVM.value.baseData.status_ML !== 'Draft') {
                return true;
            }

            const hoModifiers = _.get(submissionVM, 'lobData.homeowners.modifiers_ML');
            const jumpToQuote = _.get(history, 'location.state.jumpToQuote', false)
            if (hoModifiers) {
                const dwellingModifiersValues = _.values(hoModifiers.dwellingsModifiers_ML.value);
                if (isModernProduct && isRenters && _.isEmpty(dwellingModifiersValues)) {
                    return true;
                }
                return jumpToQuote || dwellingModifiersValues.some((mod) => mod.savedFromPortal === true);
            }        

            if (jumpToQuote) {
                return true;
            }

            return false;
        }
    };

    const fetchData = async() => {
        if ((isGpa || isQnB) && (!isSkipping || (isSkipping && !skipOnResumeIf())) && !nextStepVisited()) {
            showProgressDialog(platformMessages.syncing);
            try {
                const submissionData = await LoadSaveService.assignPolicyNumbersToModifiers(submissionVM.value, authHeader);
                _.set(modifiers.lineModifiers_ML, 'value', submissionData.lobData.homeowners.modifiers_ML.lineModifiers_ML);
                syncModifiers(submissionData.lobData.homeowners.modifiers_ML.lineModifiers_ML, modifiers.lineModifiers_ML);
                updateWizardData(submissionVM);
            } catch (e) {
                console.log(e);
            } finally {
                hideProgressDialog();
            }

        }

        submissionVM.value.cleanUpCompRaterMockPolicyNumbers();

        if ((!isSkipping || (isSkipping && !skipOnResumeIf()))) {
            modifiers.lineModifiers_ML.forEach((mod) => {
                if (mod?.savedFromPortal !== undefined && !multipolicyLobCodes.includes(mod?.codeIdentifier_ML) && !HOP_POLICY_NUMBER_MODIFIERS.includes(mod?.codeIdentifier_ML)) {
                    _.set(mod, 'savedFromPortal.value', true);
                    _.set(mod, 'editMode_ML.value', true);
                }
            });
            modifiers.dwellingsModifiers_ML.forEach((mod) => {
                if (mod?.savedFromPortal !== undefined) {
                    _.set(mod, 'savedFromPortal.value', true);
                    _.set(mod, 'editMode_ML.value', true);
                }
            });

            const initDwellingDateModifiers = () => {
                let date = new Date();
                const dateModifiers = ['zk9gmhjs1bsr143asmo0m9nmlga', 'z50j8jrtptqs14rv13ms7vbppt8', 'zipj8i6jij6ulbada49qcopeota'];
                const modifier = modifiers.dwellingsModifiers_ML.children[0];
                modifiers.dwellingsModifiers_ML.forEach((mod) => {
                    if (mod?.patternCode !== undefined && dateModifiers.includes(mod?.patternCode?.value)) {
                        if (mod.dateValue_ML.year !== undefined && mod.dateValue_ML.month !== undefined && mod.dateValue_ML.day !== undefined) {
                            date = new Date(
                                mod.dateValue_ML.year.value,
                                mod.dateValue_ML.month.value,
                                mod.dateValue_ML.day.value
                            );
                        }
                        _.set(mod, 'chosenTermValue.value', date);
                        _.set(mod, 'dateValue_ML.value', MLLocalDateUtil.date2LocalDate(date));
                    }
                });
            };

            initDwellingDateModifiers();
        }
    }

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const addAlertForEachModifierIssue = useCallback(() => {
        dateModifiersInvalid.forEach((modifier) => {
            const modifierString = translator(messages.dateCannotBePriorYearBuilt, { nameOfModifier: modifier });
            addErrorAlert(modifierString, modifier);
        });
    }, [addErrorAlert, dateModifiersInvalid, translator]);

    const fieldValuesAreNotAvailable = useCallback(() => {
        if (isModernProduct && (isLandlordCondo || isLandlordHome)) {
            const tenantValue = submissionVM.lobData.homeowners.coverables.constructionDetails_ML?.tenantScreening
            const numberOfVacantRent = submissionVM.lobData.homeowners.coverables.constructionDetails_ML?.numberOfVacantRent

            if (isOccupancyVacant && tenantValue?.length > 0) {
                updateTenantScreeningValues([]);
                _.set(
                    submissionVM,
                    'lobData.homeowners.coverables.constructionDetails_ML.tenantScreening.value',
                    []
                );
            }

            if (tenantValue && tenantValue.length == 0 && !isOccupancyVacant) {
                addErrorAlert(translator(messages.tenantValueRequired), 'tenantRequiredError');
                return true
            }
            if (_.isUndefined(numberOfVacantRent.value) || (numberOfVacantRent.value < 1 || numberOfVacantRent.value > 99) || numberOfVacantRent.value === '') {
                return true
            }
            return false

        }
        return false
    }, [submissionVM.lobData.homeowners.coverables.constructionDetails_ML]);

    const inValidOptionSelectedNP = useCallback(() => {
        updateInValidOptionSelected(undefined)

        if (isModernProduct && (isLandlordCondo || isLandlordHome) && !isOccupancyVacant) {

            const tenantValueRaw =
                submissionVM.lobData.homeowners.coverables.constructionDetails_ML?.tenantScreening || []

            const tenantValue = Array.isArray(tenantValueRaw)
                ? tenantValueRaw
                : tenantValueRaw?.value || [];

            if (tenantValue.length === 0) {
                updateInValidOptionSelected(messages.requiredDetailsMissingError)
                return true
            }

            const hasNoneApply = tenantValue.includes('none_apply')

            // none_apply + other options selected
            if (hasNoneApply && tenantValue.length > 1) {
                updateInValidOptionSelected(messages.inValidOptionselected);
                return true
            }

            // only none_apply selected
            if (hasNoneApply && tenantValue.length === 1) {
                updateInValidOptionSelected(undefined);
                return false
            }
        }

        return false

    }, [submissionVM.lobData.homeowners.coverables.constructionDetails_ML])

    const convertToDate = ({ year, month, day }) =>
            new Date(year, month - 1, day);

    const inValidateDateSelected = (dwellingMods) => {
        let hasError = false;
        if(!isModernProduct) return;
        const hasCertifiedIBHS = dwellingMods.value.some(
            (m) =>
                m?.codeIdentifier_ML === 'HOPHasCertifiedIBHS_ML' &&
                (m?.chosenTermValue === true || m?.chosenTermValue === "true")
        );
        const hasWildFirHomeDesginated = dwellingMods.value.some(
            (m) => 
                m?.codeIdentifier_ML === 'HOPIBHSWildfireHomepreparedDesignated_Ext' &&
            (m?.chosenTermValue === true || m?.chosenTermValue === "true")
        )
        dwellingMods.forEach((mod) => {
            if (mod?.value?.codeIdentifier_ML === 'HOPHomePurchaseDate_Ext') {
                const date = submissionVM.baseData?.periodStartDate.value;
                if (mod?.dateValue_ML?.value == undefined) {
                    hasError = false
                }
                else {
                    const selectedDate = convertToDate(mod?.dateValue_ML?.value);
                    const effectiveDate = convertToDate(
                        submissionVM.baseData.periodStartDate.value
                    );
                    if (selectedDate && (selectedDate > effectiveDate)) {
                        addErrorAlert('Home Purchase Date cannot be later than policy effective date', 'purchaseDateError');
                        hasError = true;
                    }
                }
            }
            else if ((hasCertifiedIBHS && mod?.value?.codeIdentifier_ML === 'HOPIBHSCertDate_ext') || (hasWildFirHomeDesginated && mod?.value?.codeIdentifier_ML === 'HOPWildfireCertDate_Ext')) {
                const date = submissionVM.baseData?.periodStartDate.value;
                if (mod?.dateValue_ML?.value == undefined) {
                    addErrorAlert('Certicate Expiration Date is required', 'certificateExpirationDateError');
                    hasError = true
                }
                else {
                    const selectedDate = convertToDate(mod?.dateValue_ML?.value);
                    const effectiveDate = convertToDate(
                        submissionVM.baseData.periodStartDate.value
                    );
                    if (selectedDate && (selectedDate <= effectiveDate)) {
                        addErrorAlert('Certification Expiration Date must be later than the transaction effective date.', 'certificateExpirationDateError');
                        hasError = true
                    }
                }
            }
        })

        return hasError;
    };

    const hasInvalidModifier = useCallback(() => {
        const invalidLineMod = modifiers.lineModifiers_ML.children.some((mod) => !mod.aspects.valid || !mod.aspects.subtreeValid);
        const invalidDwellingMod = modifiers.dwellingsModifiers_ML.children.some((mod) => !mod.aspects.valid || !mod.aspects.subtreeValid);
        return invalidLineMod || invalidDwellingMod;
    }, [modifiers.dwellingsModifiers_ML.children, modifiers.lineModifiers_ML.children]);

    const updateDraftSubmissionOnRequote = useCallback(async(subVM) => {
        showProgressDialog(platformMessages.saveSubmission);
        try {
            const submissionData = await LoadSaveService.assignPolicyNumbersToModifiers(subVM.value, authHeader);
            _.set(modifiers.lineModifiers_ML, 'value', submissionData.lobData.homeowners.modifiers_ML.lineModifiers_ML);
            syncModifiers(submissionData.lobData.homeowners.modifiers_ML.lineModifiers_ML, modifiers.lineModifiers_ML);

            const res = await LoadSaveService.updateDraftSubmission(submissionVM.value, authHeader);
            submissionVM.value = res;
            updateWizardData(submissionVM);
        } finally {
            hideProgressDialog(platformMessages.saveSubmission);
            return submissionVM;
        }
    }, [LoadSaveService, authHeader, hideProgressDialog, modifiers.lineModifiers_ML, showProgressDialog, submissionVM, syncModifiers, updateWizardData]);


    const validateData = useCallback( (isReturnToQuote = false) => {
        updateInValidOptionSelected(undefined);
        _.set(submissionVM, 'portalCurrentStep_ML.value', currentStep.mlStepName);

        clearErrorAlerts();
        
        const priorDateValidationErrors = validatePriorDateModifiersOnContinue(modifiers.dwellingsModifiers_ML);
        const futureDateValidationErrors = validateFutureDateModifiersOnContinue(modifiers.dwellingsModifiers_ML);

        if (priorDateValidationErrors.length > 0 || futureDateValidationErrors.length > 0) {
            priorDateValidationErrors.forEach((modifier) => {
                const modifierString = translator(messages.dateCannotBePriorYearBuilt, { nameOfModifier: modifier });
                
                addErrorAlert(modifierString, `${modifier} - Prior`);
            });
            futureDateValidationErrors.forEach((modifier) => {
                const modifierString = translator(messages.dateCannotBeAfterTodaysDate, { nameOfModifier: modifier });
                
                addErrorAlert(modifierString, `${modifier} - After`);
            });

            return false;
        }

        if (dateModifiersInvalid.length > 0) {
            addAlertForEachModifierIssue();
            return false;
        }

        if (inValidateDateSelected(modifiers.dwellingsModifiers_ML)) {
            setTimeout(() => {
                setErrorTimestamp(errorTimestamp + 1);
            }, 500);
            return false;
        }

        if (hasInvalidModifier()) {
            updateShowErrors(true);
            setTimeout(()=>{
                setErrorTimestamp(errorTimestamp+1);
            }, 500);
            return false;
        }

        if(fieldValuesAreNotAvailable()) {
            updateShowErrors(true);
            setTimeout(()=>{
                setErrorTimestamp(errorTimestamp+1);
            }, 500);
            return false;
        }

        if(inValidOptionSelectedNP()){
            updateInValidOptionSelected(messages.inValidOptionselected)
            updateShowErrors(true);
            setTimeout(()=>{
                setErrorTimestamp(errorTimestamp+1);
            }, 500);
            return false;
        }

        if (isReturnToQuote) {
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteDetails', authHeader);
        }
        
        return true;
    }, [addAlertForEachModifierIssue, authHeader, clearErrorAlerts, currentStep.mlStepName, dateModifiersInvalid.length, errorTimestamp, hasInvalidModifier, submissionVM]);

    const onNext = useCallback(async () => {
        if (isGpa && !returnToQuoteClicked) {
            UserService.getCurrentUser(authHeader).then((user) => {
                HOTrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'Discount Page', action: 'Discount Page Submitted'});
            });
        } else if (!isGpa) {
            HOTrackEvent('Quote Step Submitted', false, submissionVM, null, { step: 'Discount Page', action: 'Discount Page Submitted'}, true);
        }

        const isDataValid = await validateData(returnToQuoteClicked);
        if (!isDataValid) {
            return false;
        }

        if (returnToQuoteClicked) {
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteDetails', authHeader);
        } else {
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'hoAddtlInfoToQuote', authHeader);
        }
        showProgressDialog(platformMessages.syncingDiscounts);

        try {
            const submissionData =  await LoadSaveService.assignPolicyNumbersToModifiers(submissionVM.value, authHeader);
            _.set(modifiers.lineModifiers_ML, 'value', submissionData.lobData.homeowners.modifiers_ML.lineModifiers_ML);
            syncModifiers(submissionData.lobData.homeowners.modifiers_ML.lineModifiers_ML, modifiers.lineModifiers_ML);
            updateWizardData(submissionVM);
            
            if (returnToQuoteClicked) {
                showProgressDialog(platformMessages.saveSubmission, null, false, 0);
                const submissionData = await LoadSaveService.updateDraftSubmission(submissionVM.value, authHeader);
                _.set(submissionVM, 'value', submissionData);
                updateWizardData(submissionVM);

                const zip = _.get(submissionVM, 'baseData.policyAddress.postalCode.value').substring(0, 5);
                history.push('/quoteentry', {quoteID: submissionVM.quoteID.value, postalCode: zip, returnToQuoteFlag: 'true'});
            }
        } catch (e) {
            console.log(e);
        } finally {
            hideProgressDialog();
        }

        if (!nextStepVisited()) {
            return submissionVM;
        }

        goNext();
        
        return false;
    }, [LoadSaveService, authHeader, currentStep.mlStepName, goNext, hideProgressDialog, history, isGpa, modifiers.lineModifiers_ML, nextStepVisited, returnToQuoteClicked, showProgressDialog, submissionVM, syncModifiers, updateWizardData, validateData]);

    const onReturnToQuoteClicked = useCallback(() => {
        returnToQuoteClicked = true;
        onNext();
    }, [onNext]);

    const getNextDescription = useCallback(() => {
        return (isModernProduct ?
            <FormattedMessage
                {...messages.nextDescription}
                values={{
                    additionalInformation: <strong>{translator(messages.disclosure)}</strong>
                }}
            /> : <FormattedMessage
                {...messages.nextDescription}
                values={{
                    additionalInformation: <strong>{translator(messages.additionalInformation)}</strong>
                }}
            />
        );
    }, [translator, isModernProduct]);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            modifiercomponent: MLModifierComponent,
            MultipleSelect,
            CheckboxGroupFieldInternal
        },
        resolveCallbackMap: {
            onNext
        },
    };

    const getAvailableTenantTypeList = () => [
        { code: 'credit_check', name: 'Credit check' },
        { code: 'criminal_background_check', name: 'Criminal background check' },
        { code: 'eviction_search', name: 'Eviction search' },
        { code: 'ho4_tenant_policy_on_file', name: 'HO4 tenant policy on file' },
        { code: 'skip_search', name: 'Skip search' },
        { code: 'none_apply', name: 'None apply' },
    ];

    const overrides = {
        gpaPageHeader: {
            visible: isGpa
        },
        pageContainer: {
            className: isGpa ? 'page-content-gpa' : undefined
        },
        lineModifier: {
            modifier: modifiers.lineModifiers_ML,
            showValidationErrors: showErrors,
            onValidate: onValidate,
            updateModifier: updateModifier,
            isHomeowners: true
        },
        dwellingsModifier: {
            modifier: modifiers.dwellingsModifiers_ML,
            showValidationErrors: showErrors,
            onValidate: onValidate,
            updateModifier: updateModifier,
            isHomeowners: true,
            modifierIdToAppend: 'dwellingsMod',
            submissionVM
        },
        constructionModifier: {
            visible: isGpa && isRentalPolicy,
            modifier: modifiers.dwellingConstructionModifiers_ML,
            showValidationErrors: showErrors,
            onValidate: onValidate,
            updateModifier: updateModifier,
            isHomeowners: true,
            modifierIdToAppend: 'dwellingConstructionMod'
        },
        stickyContinueSection: {
            visible: isGpa,
            defaultContinueSectionId: 'footer',
            nextDescription: getNextDescription(),
            onNext,
            showReturnToQuote
        },
        nextDescription: {
            content: getNextDescription()
        },
        returnToQuoteButton: {
            visible: showReturnToQuote,
            disabled: true
        },
        additionalQsContainer: {
            visible: isModernProduct && (isLandlordHome || isLandlordCondo),
        },
        numberOfRentalVacantSite: {           
            required: isModernProduct && (isLandlordHome || isLandlordCondo),
            showValidationErrors: showErrors
        },
        tenantScreeningLabel: {
            visible: isModernProduct && (isLandlordHome || isLandlordCondo) && !isOccupancyVacant
        },
        tenantScreening: {
            visible: isModernProduct && (isLandlordHome || isLandlordCondo) && !isOccupancyVacant,
            required: isModernProduct && (isLandlordHome || isLandlordCondo) && !isOccupancyVacant,
            showValidationErrors: showErrors,
            availableValues: getAvailableTenantTypeList(),
            onValueChange: values => {
                updateTenantScreeningValues(values);
                _.set(
                    submissionVM,
                    'lobData.homeowners.coverables.constructionDetails_ML.tenantScreening',
                    values
                );
                updateWizardData(submissionVM);
                refreshData();
            },
            value: _.get(
                    submissionVM,
                    'lobData.homeowners.coverables.constructionDetails_ML.tenantScreening.value',
                    []
                ),
            tooltip: {
                text: 
                (<FormattedMessage
                    {...messages.tenantScreeningTooltip}
                    values={{
                        b: chunks => <strong>{chunks}</strong>,
                        br: () => <br/>,
                        p: chunks => <p>{chunks}</p>
                    }}
                />)
            }
        },
        tenantOptionError: {
            visible: !(_.isUndefined(inValidOptionSelected)) && inValidOptionSelected,
            messageProps: {
                error: inValidOptionSelected
            }
        },
        defensibleDiscountNotification: {
            visible: _.get(submissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.defensibleDiscountVisible.value', false)
        },
        defensibleDiscountValue: {
            visible: !_.isUndefined(defensibleValue), 
            content: _.get(submissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.defensibleDiscount.value', "")
        },
        defensibleDiscountUnavailableNote: {
            visible: _.isUndefined(defensibleValue)
        }
    };

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            skipWhen={skipOnResumeIf}
            showNext={!nextStepVisited()}
            onNext={onNext}
            nextLabel={translator(platformMessages.mlContinue)}
            showTextNextToButton={!nextStepVisited()}
            textNextToButton={getNextDescription()}
            metadataPageId={!nextStepVisited() && _.get(metadata, 'pageContent.id')}
            stickyComponentOverrideId='stickyContinueSection'
            showReturnToQuote={showReturnToQuote && canRequote}
            disableReturnToQuote={!canRequote}
            updateWizardData={updateWizardData}
            validateData={validateData}
            history={history}
            onReturnToQuote={onReturnToQuoteClicked}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                model={submissionVM}
                onModelChange={updateWizardData}
                componentMap={resolvers.resolveComponentMap}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                onValidationChange={onValidate}
                showErrors={showErrors}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
}

AdditionalDiscountsPage.propTypes = wizardProps;
export default withRouter(AdditionalDiscountsPage);
